import { z } from "zod";

export const PathCmdSchema = z.discriminatedUnion("c", [
  z.object({ c: z.literal("M"), x: z.number(), y: z.number() }),
  z.object({ c: z.literal("L"), x: z.number(), y: z.number() }),
  z.object({
    c: z.literal("C"),
    x1: z.number(), y1: z.number(), x2: z.number(), y2: z.number(), x: z.number(), y: z.number(),
  }),
  z.object({ c: z.literal("Q"), x1: z.number(), y1: z.number(), x: z.number(), y: z.number() }),
  /** a:arcTo: ellipse radii + start/sweep angles in degrees; converted to an SVG arc at render time. */
  z.object({ c: z.literal("A"), wR: z.number(), hR: z.number(), stAng: z.number(), swAng: z.number() }),
  z.object({ c: z.literal("Z") }),
]);
export type PathCmd = z.infer<typeof PathCmdSchema>;

export const GeomPathSchema = z.object({
  /** Path coordinate space (a:path@w/@h). 0 means "use the shape's w/h". */
  w: z.number().default(0),
  h: z.number().default(0),
  fill: z.enum(["norm", "none", "lighten", "darken", "lightenLess", "darkenLess"]).default("norm"),
  stroke: z.boolean().default(true),
  cmds: z.array(PathCmdSchema),
});
export type GeomPath = z.infer<typeof GeomPathSchema>;

export const GeometrySchema = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("preset"),
    preset: z.string(),
    /** a:avLst guide overrides, e.g. { adj: 16667 } */
    adjust: z.record(z.number()).optional(),
    /** false when the preset is not in our table; renderer falls back to rect */
    supported: z.boolean().default(true),
  }),
  z.object({ kind: z.literal("custom"), paths: z.array(GeomPathSchema) }),
]);
export type Geometry = z.infer<typeof GeometrySchema>;
